import auditSummary from './audit_summary.vue';

export default auditSummary;
